var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('x-dialog',{attrs:{"width":"50%","dialogTitle":_vm.dialogTitle,"dialogState":_vm.dialogState,"actions":{
    show: true,
    primaryButtonShow: true,
    primaryButtonText: _vm.primaryButtonText,
    secondaryButtonText: _vm.secondaryButtonText,
    secondaryButtonFunction: _vm.closeDialog,
    primaryButtonFunction: _vm.triggerExport,
    primaryButtonDisabled: _vm.primaryButtonDisabled
  }},on:{"toggleModal":_vm.closeDialog}},[_c('div',{staticClass:"d-flex flex-col w-100",attrs:{"slot":"dialog_data"},slot:"dialog_data"},[(_vm.exportJobInProgress)?_c('loader'):_vm._e(),_c('div',[_c('p',[_vm._v(_vm._s(_vm.optionsText))]),_c('export-options-list',{attrs:{"exportOptionsArray":_vm.exportOptionsArray,"selectedOption":_vm.selectedOption},on:{"updateSelectedOption":_vm.updateSelectedOption}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }